import { initHttp } from '../utils/http';
import { emit } from '../events/notifier';

/**
 * @summary function to create adapter for source
 * @namespace Source
 * @param {Function} SourceConstructor function
 * @param {Object} settings
 */
export function createSource(SourceConstructor, settings) {
  if (settings === void 0) {
    settings = {};
  }
  if (typeof SourceConstructor !== 'function') {
    throw new Error('Source constructor should be a function');
  }
  if (typeof settings !== 'undefined' && (typeof settings !== 'object' || settings === null)) {
    throw new Error('Source settings should be an object');
  }
  const http = initHttp();
  return new SourceConstructor(settings, emit, http);
}